import {
  IAdditionalData,
  WSDataTypes
} from "@wingspanhq/payments/dist/interfaces";
import { convertDataTypeBooleanToString } from "../../../shared/utils/convertDataTypeBoolean";

export function getCustomFieldsLabelsRequest(
  formFields: IAdditionalData[],
  values: { [key: string]: any }
) {
  const labels: any = {};
  formFields.forEach(field => {
    switch (field.type) {
      case WSDataTypes.String:
        labels[field.key] = values[field.key] ? String(values[field.key]) : "";
        break;

      case WSDataTypes.Boolean:
        labels[field.key] = convertDataTypeBooleanToString(values[field.key]);
        break;
    }
  });
  return labels;
}
